import { Column, Row } from '@grubhubprod/gh-cookbook-react';
import React, { ComponentType } from 'react';

export const withRow = <P,>(
  Component: ComponentType<P>
): React.FunctionComponent<P> => {
  return function WithRow(props: P): JSX.Element {
    return (
      <Row>
        <Column phone={4}>
          <Component {...props} />
        </Column>
      </Row>
    );
  };
};
